const validateTokens = async (amount, userInfo) => {

//Verify that user can pay for image generation
try{
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
    const response = await fetch(`${API_BASE_URL}/validate-token-amount`,{
        method:'POST',
        headers:{
            'Content-Type':'application/json',
            "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
        },
        body:JSON.stringify({
            userInfo: userInfo,
            amount: amount
        })
    });
    const result = await response.json()
    if(result.message === 'Sufficient Token Amount'){
        return true   
    }
    else if(result.message === 'Not Enough Tokens'){
        console.log('Not enough tokens')
        
        return false
    }
    else{
        
        return null
    }

}catch(err){
    return null
}
}

export default validateTokens